//FONTS SIZES
export const TITLE_SIZE = "34px";
export const SUB_TITLE_SIZE = "26px";
export const TEXT_SIZE = "20px";
export const SUB_TEXT_SIZE = "16px";
export const MINIMAL_TEXT_SIZE = "14px";
